//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateItem } from '@/api/shoppingcart';
import { verifyId, verifyId_HUZHAO, verifyId_GANGAO, verifyId_TAIBAO } from '@/utils/validate';
export default {
  data: function data() {
    return {
      type: 'add',
      visible: false,
      form: {
        guest_name: '',
        guest_identify: '',
        guest_papers_type: 'ID_CARD',
        guest_phone: ''
      },
      options: [{
        value: 'ID_CARD',
        label: '身份证'
      }, {
        value: 'HUZHAO',
        label: '护照'
      }, {
        value: 'GANGAO',
        label: '港澳通行证'
      }, {
        value: 'TAIBAO',
        label: '台湾通行证'
      }],
      contacts: [],
      validateList: {
        'ID_CARD': verifyId,
        'HUZHAO': verifyId_HUZHAO,
        'GANGAO': verifyId_GANGAO,
        'TAIBAO': verifyId_TAIBAO
      }
    };
  },
  computed: {
    projectConfig: function projectConfig() {
      return this.$store.state.projectConfig;
    },
    needIdentifyType: function needIdentifyType() {
      // 是否需要其他证件类型
      return this.projectConfig && this.projectConfig.support_identity_type.length > 1;
    }
  },
  methods: {
    verifyId: verifyId,
    show: function show(item) {
      console.log('item', item);
      this.item = item;
      this.visible = true;
      this.form.guest_name = item.guest_name;
      this.form.guest_identify = item.guest_identify;
      this.form.guest_papers_type = item.guest_papers_type;
      this.$nextTick(function () {// this.$refs.form.resetFields()
      });
    },
    onSubmit: function onSubmit(values) {
      var _this = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var _this$form = _this.form,
            guest_name = _this$form.guest_name,
            guest_identify = _this$form.guest_identify,
            guest_papers_type = _this$form.guest_papers_type;
        var params = Object.assign({}, _this.item, {
          guest_name: guest_name,
          guest_identify: guest_identify,
          guest_papers_type: guest_papers_type
        });
        updateItem(params).then(function (res) {
          _this.$message.success('更新成功');

          _this.$store.dispatch('getCartItems');

          _this.visible = false;
        });
      });
    }
  }
};